import {
  LOADING_ORDER_SALES_REPOORT,
  SET_ORDER_SALES_REPOORT,
  ORDER_SALES_REPORT_ERROR,
} from './reports.type';
import initialState from '../initialState';

const reportState = {
  ...initialState,
  orderSalesReport: null,
  loadingOrderSales: true,
  orderSalesError: '',
};

const reportsReducer = (state = reportState, action) => {
  switch (action.type) {
    case LOADING_ORDER_SALES_REPOORT:
      return {
        ...state,
        loadingOrderSales: action.value,
      };

    case SET_ORDER_SALES_REPOORT:
      return {
        ...state,
        orderSalesReport: action.report,
      };

    case ORDER_SALES_REPORT_ERROR:
      return {
        ...state,
        orderSalesError: action.error,
      };

    default:
      return state;
  }
};

export default reportsReducer;
